import React, { useEffect, useMemo, useRef, useState } from "react";
import "./style.css";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import MapComponent from "../../components/MAPA-COMP/mapa-comp";
import firebase from "../../config/firebase";
import freightService from "../../service/freight.service";
import StepPoints from "../../components/step-folow-driver/comp-step-driver";
import CardFolowFreigth from "../../components/card-info-folow-freight/card-freigth-folow";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import paymentService from "../../service/payment.service";
import driverService from "../../service/driver.service";
import { QRCodeCanvas } from "qrcode.react";

require("firebase/auth");

const ALERT_THRESHOLDS = {
  gpsStaleWarningMs: 20 * 60 * 1000,
  gpsStaleCriticalMs: 40 * 60 * 1000,
  deliveryDelayToleranceMs: 2 * 60 * 60 * 1000,
  lowProgressPercent: 60,
  longTripMs: 10 * 60 * 60 * 1000,
  routeDeviationWarningKm: 3,
  routeDeviationCriticalKm: 8,
  minSpeedForEtaKmh: 8,
  etaLookbackPoints: 8,
  unplannedStopMinDurationMs: 25 * 60 * 1000,
  unplannedStopMaxMovementKm: 0.4,
  unplannedStopMinDistanceFromStopKm: 1.2,
};
const HISTORY_ALERTS_LIMIT = 20;
const HISTORY_RETENTION_DAYS = 30;

export default function ViewerFreights() {
  const db = firebase.firestore();
  const { id } = useParams();
  const user = useSelector(state=> state.user);

  const [points, setPoints] = useState([]);
  const [positions, setPositions] = useState([]);
  const [freightData, setFreightData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stoppingPointsUrl, setStoppingPointsUrl] = useState("");
  const [positionsUrl, setPositionsUrl] = useState("");
  const [nameDriver, setNameDriver] = useState("");
  const [publicTrackUrl, setPublicTrackUrl] = useState("");
  const [isGeneratingTrackLink, setIsGeneratingTrackLink] = useState(false);
  const [trackLinkValidityHours, setTrackLinkValidityHours] = useState(72);
  const [timelineFilter, setTimelineFilter] = useState("all");
  const [showFullTimeline, setShowFullTimeline] = useState(false);
  const [recentOperationalAlerts, setRecentOperationalAlerts] = useState([]);
  const [historyAlertFilter, setHistoryAlertFilter] = useState("all");
  const persistedAlertKeysRef = useRef(new Set());
  const parseTimestampToMs = (rawTs) => {
    if (rawTs === null || rawTs === undefined || rawTs === "") return null;
    if (typeof rawTs?.toDate === "function") {
      const d = rawTs.toDate();
      return Number.isNaN(d.getTime()) ? null : d.getTime();
    }
    if (typeof rawTs === "number") return rawTs;
    if (typeof rawTs === "string") {
      const asNumber = Number(rawTs);
      if (!Number.isNaN(asNumber) && asNumber > 0) return asNumber;
      const parsed = new Date(rawTs).getTime();
      return Number.isNaN(parsed) ? null : parsed;
    }
    const parsed = new Date(rawTs).getTime();
    return Number.isNaN(parsed) ? null : parsed;
  };
  const toCartesianKm = (lat, lng, refLat) => {
    const x = lng * 111.32 * Math.cos((refLat * Math.PI) / 180);
    const y = lat * 110.57;
    return { x, y };
  };
  const distanceBetweenCoordsKm = (coordA, coordB) => {
    if (!coordA || !coordB) return 0;
    const [lat1, lon1] = coordA;
    const [lat2, lon2] = coordB;
    const toRad = (deg) => (deg * Math.PI) / 180;
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };
  const pointToSegmentDistanceKm = (point, segStart, segEnd) => {
    const refLat = (point[0] + segStart[0] + segEnd[0]) / 3;
    const p = toCartesianKm(point[0], point[1], refLat);
    const a = toCartesianKm(segStart[0], segStart[1], refLat);
    const b = toCartesianKm(segEnd[0], segEnd[1], refLat);
    const abx = b.x - a.x;
    const aby = b.y - a.y;
    const apx = p.x - a.x;
    const apy = p.y - a.y;
    const denom = abx * abx + aby * aby;
    if (!denom) {
      return Math.hypot(apx, apy);
    }
    const t = Math.max(0, Math.min(1, (apx * abx + apy * aby) / denom));
    const projX = a.x + t * abx;
    const projY = a.y + t * aby;
    return Math.hypot(p.x - projX, p.y - projY);
  };

  const formatRelativeMinutes = (diffMs) => {
    const diffMinutes = Math.floor(diffMs / (60 * 1000));
    if (diffMinutes < 1) return "Agora";
    if (diffMinutes < 60) return `Ha ${diffMinutes} min`;
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    return minutes > 0 ? `Ha ${hours}h ${minutes}min` : `Ha ${hours}h`;
  };
  const formatDuration = (diffMs) => {
    if (!diffMs || diffMs < 0) return "0min";
    const totalMinutes = Math.floor(diffMs / (60 * 1000));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;
    if (days > 0) {
      return `${days}d ${hours}h ${minutes}min`;
    }
    if (hours > 0) {
      return `${hours}h ${minutes}min`;
    }
    return `${minutes}min`;
  };
  const formatDateTime = (raw) => {
    const ms = parseTimestampToMs(raw);
    if (!ms) return "Indisponivel";
    return new Date(ms).toLocaleString("pt-BR");
  };

  const isFreightFinished = useMemo(() => {
    const stops = freightData?.subcollectionData || [];
    if (stops.length === 0) return false;
    const lastStop = stops[stops.length - 1];
    return lastStop?.concluded === true;
  }, [freightData]);
  const concludedStops = useMemo(
    () => points.filter((point) => point?.concluded).length,
    [points]
  );
  const progressPercent = useMemo(() => {
    if (!points.length) return 0;
    return Math.round((concludedStops / points.length) * 100);
  }, [concludedStops, points.length]);
  const lastGpsTimestampMs = useMemo(() => {
    if (!positions.length) return null;
    return positions.reduce((latest, current) => {
      const ts = parseTimestampToMs(current?.timestamp);
      if (!ts) return latest;
      if (!latest) return ts;
      return ts > latest ? ts : latest;
    }, null);
  }, [positions]);
  const latestGpsPosition = useMemo(() => {
    if (!positions.length) return null;
    const sorted = [...positions].sort((a, b) => {
      const ta = parseTimestampToMs(a?.timestamp) || 0;
      const tb = parseTimestampToMs(b?.timestamp) || 0;
      return tb - ta;
    });
    const latest = sorted[0];
    if (!latest?.coords || latest.coords.length !== 2) return null;
    return latest.coords;
  }, [positions]);
  const routeDeviationKm = useMemo(() => {
    const planned = (points || [])
      .map((item) => item?.coords)
      .filter(
        (coord) =>
          Array.isArray(coord) &&
          coord.length === 2 &&
          typeof coord[0] === "number" &&
          typeof coord[1] === "number"
      );
    if (!latestGpsPosition || planned.length < 2) return null;
    let minDistance = Infinity;
    for (let i = 0; i < planned.length - 1; i += 1) {
      const dist = pointToSegmentDistanceKm(
        latestGpsPosition,
        planned[i],
        planned[i + 1]
      );
      if (dist < minDistance) minDistance = dist;
    }
    return Number.isFinite(minDistance) ? minDistance : null;
  }, [latestGpsPosition, points]);
  const routeDeviationDisplay = useMemo(() => {
    if (routeDeviationKm === null) {
      return { text: "Indisponivel", color: "#64748b" };
    }
    if (routeDeviationKm >= ALERT_THRESHOLDS.routeDeviationCriticalKm) {
      return { text: `${routeDeviationKm.toFixed(1)} km`, color: "#b91c1c" };
    }
    if (routeDeviationKm >= ALERT_THRESHOLDS.routeDeviationWarningKm) {
      return { text: `${routeDeviationKm.toFixed(1)} km`, color: "#92400e" };
    }
    return { text: `${routeDeviationKm.toFixed(1)} km`, color: "#166534" };
  }, [routeDeviationKm]);
  const etaData = useMemo(() => {
    const planned = (points || [])
      .map((item) => item?.coords)
      .filter(
        (coord) =>
          Array.isArray(coord) &&
          coord.length === 2 &&
          typeof coord[0] === "number" &&
          typeof coord[1] === "number"
      );
    if (!latestGpsPosition || planned.length === 0) {
      return {
        etaMs: null,
        etaLabel: "ETA indisponivel",
        speedKmh: null,
        remainingKm: null,
      };
    }

    const destination = planned[planned.length - 1];
    const remainingKm = distanceBetweenCoordsKm(latestGpsPosition, destination);

    const orderedPositions = [...positions]
      .map((p) => ({
        coords: p?.coords,
        ts: parseTimestampToMs(p?.timestamp),
      }))
      .filter(
        (p) =>
          p.ts &&
          Array.isArray(p.coords) &&
          p.coords.length === 2 &&
          typeof p.coords[0] === "number" &&
          typeof p.coords[1] === "number"
      )
      .sort((a, b) => a.ts - b.ts);

    const lookback = orderedPositions.slice(-ALERT_THRESHOLDS.etaLookbackPoints);
    if (lookback.length < 2) {
      return {
        etaMs: null,
        etaLabel: "ETA indisponivel",
        speedKmh: null,
        remainingKm,
      };
    }

    let totalDistanceKm = 0;
    let totalTimeHours = 0;
    for (let i = 1; i < lookback.length; i += 1) {
      const d = distanceBetweenCoordsKm(lookback[i - 1].coords, lookback[i].coords);
      const h = (lookback[i].ts - lookback[i - 1].ts) / (60 * 60 * 1000);
      if (h > 0 && d >= 0) {
        totalDistanceKm += d;
        totalTimeHours += h;
      }
    }

    if (!totalTimeHours || totalDistanceKm <= 0) {
      return {
        etaMs: null,
        etaLabel: "ETA indisponivel",
        speedKmh: null,
        remainingKm,
      };
    }

    const speedKmh = totalDistanceKm / totalTimeHours;
    if (speedKmh < ALERT_THRESHOLDS.minSpeedForEtaKmh || remainingKm < 0.1) {
      return {
        etaMs: null,
        etaLabel: "ETA indisponivel (sem movimento)",
        speedKmh,
        remainingKm,
      };
    }

    const etaMs = Date.now() + (remainingKm / speedKmh) * 60 * 60 * 1000;
    return {
      etaMs,
      etaLabel: new Date(etaMs).toLocaleString("pt-BR"),
      speedKmh,
      remainingKm,
    };
  }, [latestGpsPosition, points, positions]);
  const unplannedStopData = useMemo(() => {
    if (!positions?.length || !points?.length) {
      return { isConfirmed: false, durationMs: 0, movementKm: 0, awayFromStopKm: 0 };
    }

    const orderedPositions = [...positions]
      .map((p) => ({
        coords: p?.coords,
        ts: parseTimestampToMs(p?.timestamp),
      }))
      .filter(
        (p) =>
          p.ts &&
          Array.isArray(p.coords) &&
          p.coords.length === 2 &&
          typeof p.coords[0] === "number" &&
          typeof p.coords[1] === "number"
      )
      .sort((a, b) => b.ts - a.ts);

    if (orderedPositions.length < 2) {
      return { isConfirmed: false, durationMs: 0, movementKm: 0, awayFromStopKm: 0 };
    }

    const latestTs = orderedPositions[0].ts;
    const windowPositions = orderedPositions.filter(
      (p) => latestTs - p.ts <= ALERT_THRESHOLDS.unplannedStopMinDurationMs
    );
    if (windowPositions.length < 2) {
      return { isConfirmed: false, durationMs: 0, movementKm: 0, awayFromStopKm: 0 };
    }

    const oldest = windowPositions[windowPositions.length - 1];
    const newest = windowPositions[0];
    const durationMs = newest.ts - oldest.ts;
    const movementKm = distanceBetweenCoordsKm(oldest.coords, newest.coords);

    const plannedCoords = points
      .map((item) => item?.coords)
      .filter(
        (coord) =>
          Array.isArray(coord) &&
          coord.length === 2 &&
          typeof coord[0] === "number" &&
          typeof coord[1] === "number"
      );
    const awayFromStopKm = plannedCoords.reduce((minDist, coord) => {
      const d = distanceBetweenCoordsKm(newest.coords, coord);
      return d < minDist ? d : minDist;
    }, Number.POSITIVE_INFINITY);

    const isConfirmed =
      durationMs >= ALERT_THRESHOLDS.unplannedStopMinDurationMs &&
      movementKm <= ALERT_THRESHOLDS.unplannedStopMaxMovementKm &&
      awayFromStopKm >= ALERT_THRESHOLDS.unplannedStopMinDistanceFromStopKm;

    return {
      isConfirmed,
      durationMs,
      movementKm,
      awayFromStopKm: Number.isFinite(awayFromStopKm) ? awayFromStopKm : 0,
    };
  }, [points, positions]);
  const travelDurationFromStopsMs = useMemo(() => {
    const stops = freightData?.subcollectionData || [];
    if (!stops.length) return null;
    const stopTimes = stops
      .map((item) =>
        parseTimestampToMs(item?.timestamp ?? item?.createdAt ?? item?.updatedAt)
      )
      .filter(Boolean)
      .sort((a, b) => a - b);
    if (!stopTimes.length) return null;
    return stopTimes[stopTimes.length - 1] - stopTimes[0];
  }, [freightData]);
  const tripBoundsFromStops = useMemo(() => {
    const stops = freightData?.subcollectionData || [];
    if (!stops.length) return { startMs: null, endMs: null };
    const stopTimes = stops
      .map((item) =>
        parseTimestampToMs(item?.timestamp ?? item?.createdAt ?? item?.updatedAt)
      )
      .filter(Boolean)
      .sort((a, b) => a - b);
    if (!stopTimes.length) return { startMs: null, endMs: null };
    return {
      startMs: stopTimes[0],
      endMs: stopTimes[stopTimes.length - 1],
    };
  }, [freightData]);
  const gpsHealth = useMemo(() => {
    if (!lastGpsTimestampMs) {
      return {
        label: "Sem leitura recente",
        tone: "#9ca3af",
      };
    }
    const diff = Date.now() - lastGpsTimestampMs;
    if (diff <= 5 * 60 * 1000) {
      return { label: "Sinal em tempo real", tone: "#1f9d55" };
    }
    if (diff <= 15 * 60 * 1000) {
      return { label: "Atualizacao moderada", tone: "#d97706" };
    }
    return { label: "Sem atualizacao recente", tone: "#dc2626" };
  }, [lastGpsTimestampMs]);
  const expectedDeliveryMs = useMemo(() => {
    const rawDate =
      freightData?.lastDelivery?.dateColeta ||
      freightData?.freight?.lastDelivery?.dateColeta ||
      freightData?.freight?.dateColeta ||
      null;
    if (!rawDate) return null;
    const parsed = parseTimestampToMs(rawDate);
    if (parsed) return parsed;
    if (typeof rawDate === "string") {
      const asEndOfDay = new Date(`${rawDate}T23:59:59`).getTime();
      return Number.isNaN(asEndOfDay) ? null : asEndOfDay;
    }
    return null;
  }, [freightData]);
  const operationalAlerts = useMemo(() => {
    const alerts = [];
    if (isFreightFinished) return alerts;

    if (!lastGpsTimestampMs) {
      alerts.push({
        code: "gps_no_signal",
        level: "warning",
        title: "Sem sinal GPS recente",
        message: "Nao ha leitura GPS valida para este frete no momento.",
        source: "GPS",
        mapUrl: positionsUrl,
      });
      return alerts;
    }

    const staleMs = Date.now() - lastGpsTimestampMs;
    if (staleMs > ALERT_THRESHOLDS.gpsStaleCriticalMs) {
      alerts.push({
        code: "gps_stale_critical",
        level: "critical",
        title: "GPS sem atualizacao prolongada",
        message: `Rastreamento sem nova leitura de GPS ha ${formatDuration(staleMs)}.`,
        source: "GPS",
        mapUrl: positionsUrl,
      });
    } else if (staleMs > ALERT_THRESHOLDS.gpsStaleWarningMs) {
      alerts.push({
        code: "gps_stale_warning",
        level: "warning",
        title: "Atualizacao de GPS em atraso",
        message: `Ultima leitura valida do GPS foi ${formatRelativeMinutes(staleMs)}.`,
        source: "GPS",
        mapUrl: positionsUrl,
      });
    }

    if (
      expectedDeliveryMs &&
      Date.now() > expectedDeliveryMs + ALERT_THRESHOLDS.deliveryDelayToleranceMs
    ) {
      alerts.push({
        code: "deadline_delay",
        level: "critical",
        title: "Possivel atraso de entrega",
        message: `Previsao de entrega passou em ${formatDateTime(expectedDeliveryMs)}.`,
        source: "PRAZO",
        mapUrl: stoppingPointsUrl,
      });
    }
    if (
      expectedDeliveryMs &&
      etaData.etaMs &&
      etaData.etaMs > expectedDeliveryMs + ALERT_THRESHOLDS.deliveryDelayToleranceMs
    ) {
      alerts.push({
        code: "eta_delay_projection",
        level: "critical",
        title: "Atraso projetado por ETA",
        message: `ETA estimado para ${formatDateTime(
          etaData.etaMs
        )}, acima do prazo previsto.`,
        source: "ETA",
        mapUrl: positionsUrl,
      });
    }

    if (
      progressPercent < ALERT_THRESHOLDS.lowProgressPercent &&
      travelDurationFromStopsMs &&
      travelDurationFromStopsMs > ALERT_THRESHOLDS.longTripMs
    ) {
      alerts.push({
        code: "progress_below_expected",
        level: "warning",
        title: "Progresso abaixo do esperado",
        message: `Apenas ${progressPercent}% das paradas foi concluido ate agora.`,
        source: "PONTOS",
        mapUrl: stoppingPointsUrl,
      });
    }
    if (routeDeviationKm !== null) {
      if (routeDeviationKm >= ALERT_THRESHOLDS.routeDeviationCriticalKm) {
        alerts.push({
          code: "route_deviation_critical",
          level: "critical",
          title: "Desvio critico da rota",
          message: `Motorista esta a ${routeDeviationKm.toFixed(
            1
          )} km da rota planejada.`,
          source: "GPS + ROTA",
          mapUrl: positionsUrl,
        });
      } else if (routeDeviationKm >= ALERT_THRESHOLDS.routeDeviationWarningKm) {
        alerts.push({
          code: "route_deviation_warning",
          level: "warning",
          title: "Possivel desvio da rota",
          message: `Motorista esta a ${routeDeviationKm.toFixed(
            1
          )} km da rota planejada.`,
          source: "GPS + ROTA",
          mapUrl: positionsUrl,
        });
      }
    }
    if (unplannedStopData.isConfirmed) {
      alerts.push({
        code: "unplanned_stop_confirmed",
        level: "critical",
        title: "Parada nao planejada confirmada",
        message: `Baixa movimentacao por ${formatDuration(
          unplannedStopData.durationMs
        )}, a ${unplannedStopData.awayFromStopKm.toFixed(
          1
        )} km do ponto previsto.`,
        source: "GPS + PONTOS",
        mapUrl: positionsUrl,
      });
    }

    return alerts;
  }, [
    expectedDeliveryMs,
    etaData.etaMs,
    isFreightFinished,
    lastGpsTimestampMs,
    unplannedStopData.awayFromStopKm,
    unplannedStopData.durationMs,
    unplannedStopData.isConfirmed,
    positionsUrl,
    routeDeviationKm,
    stoppingPointsUrl,
    progressPercent,
    travelDurationFromStopsMs,
  ]);
  const tripTimeline = useMemo(() => {
    const stops = freightData?.subcollectionData || [];
    if (!stops.length) return [];

    const timeline = [];
    stops.forEach((stop) => {
      const stopTs = parseTimestampToMs(
        stop?.timestamp ?? stop?.createdAt ?? stop?.updatedAt
      );
      timeline.push({
        id: `stop-${stop.id}`,
        timeMs: stopTs || 0,
        type: "stop",
        title: `Parada ${stop?.stop_order || "-"}: ${stop?.name || "Sem nome"}`,
        description: stop?.concluded
          ? "Parada concluida com sucesso."
          : "Parada ainda pendente.",
      });

      (stop?.events || []).forEach((event, idx) => {
        const eventTs = parseTimestampToMs(event?.created_at);
        timeline.push({
          id: `event-${stop.id}-${idx}`,
          timeMs: eventTs || 0,
          type: "event",
          title: `Ocorrencia: ${event?.event?.desc || "Sem descricao"}`,
          description: event?.description || "Sem detalhes adicionais.",
        });
      });
    });

    return timeline.sort((a, b) => b.timeMs - a.timeMs);
  }, [freightData]);

  useEffect(() => {
    if (!id || !operationalAlerts.length) return;
    operationalAlerts.forEach((alert) => {
      const key = `${alert.code || alert.title}|${alert.level}|${alert.message}`;
      if (persistedAlertKeysRef.current.has(key)) return;
      persistedAlertKeysRef.current.add(key);
      const fingerprint = `${alert.code || "generic"}-${alert.level || "warning"}-${
        alert.source || "Sistema"
      }`.toLowerCase().replace(/\s+/g, "-");
      freightService
        .saveOperationalAlertIfNew(id, fingerprint, {
          code: alert.code || null,
          level: alert.level,
          title: alert.title,
          message: alert.message,
          source: alert.source || "Sistema",
          mapUrl: alert.mapUrl || null,
        })
        .catch((err) => {
          console.error("Erro ao persistir alerta operacional:", err);
        });
    });
  }, [id, operationalAlerts]);
  const filteredRecentOperationalAlerts = useMemo(() => {
    if (historyAlertFilter === "critical") {
      return recentOperationalAlerts.filter((item) => item.level === "critical");
    }
    if (historyAlertFilter === "warning") {
      return recentOperationalAlerts.filter((item) => item.level !== "critical");
    }
    return recentOperationalAlerts;
  }, [historyAlertFilter, recentOperationalAlerts]);

  useEffect(() => {
    if (!id) return undefined;
    const retentionMs = HISTORY_RETENTION_DAYS * 24 * 60 * 60 * 1000;
    const unsubscribe = freightService.subscribeRecentOperationalAlerts(
      id,
      HISTORY_ALERTS_LIMIT,
      (snap) => {
        const now = Date.now();
        const items = snap.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((item) => {
            const createdMs = parseTimestampToMs(item?.createdAt);
            if (!createdMs) return false;
            return now - createdMs <= retentionMs;
          });
        setRecentOperationalAlerts(items);
      },
      (err) => {
        console.error("Erro ao carregar historico de alertas:", err);
      }
    );
    return () => unsubscribe();
  }, [id]);
  const filteredTimeline = useMemo(() => {
    if (timelineFilter === "alerts") {
      return tripTimeline.filter((item) => item.type === "event");
    }
    if (timelineFilter === "stops") {
      return tripTimeline.filter((item) => item.type === "stop");
    }
    return tripTimeline;
  }, [timelineFilter, tripTimeline]);
  const visibleTimeline = useMemo(() => {
    if (showFullTimeline) return filteredTimeline;
    return filteredTimeline.slice(0, 12);
  }, [filteredTimeline, showFullTimeline]);

  // Função para calcular a distância entre duas coordenadas (Haversine Formula)
  const calculateDistance = (coord1, coord2) => {
    const [lat1, lon1] = coord1;
    const [lat2, lon2] = coord2;
    const R = 6371; // Raio da Terra em km

    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distância em km

    return distance;
  };

  // Função para gerar o link de coordenadas filtradas e unificadas
  const generateGoogleMapsLink_ = (positions) => {
    // 23 a 25
    const baseUrl = "https://www.google.com/maps/dir/";

    // Função para agrupar coordenadas muito próximas e com timestamps próximos
    const filteredPositions = positions.reduce((acc, current, index, arr) => {
      if (index === 0) {
        acc.push(current); // Adiciona o primeiro ponto
        return acc;
      }

      const prevPosition = acc[acc.length - 1]; // Último ponto no array de acumulados
      const distance = calculateDistance(current.coords, prevPosition.coords);
      const timeDifference = Math.abs(
        current.timestamp - prevPosition.timestamp
      );

      // Se a distância for maior que 0.1 km ou a diferença de tempo for maior que 5 minutos, adiciona como um novo ponto
      if (distance > 0.1 || timeDifference > 5 * 60 * 1000) {
        acc.push(current);
      } else {
        // Se for muito próximo, substitui o ponto anterior com a média dos pontos agrupados
        const avgLat = (prevPosition.coords[0] + current.coords[0]) / 2;
        const avgLon = (prevPosition.coords[1] + current.coords[1]) / 2;
        prevPosition.coords = [avgLat, avgLon];
        prevPosition.timestamp = Math.max(
          prevPosition.timestamp,
          current.timestamp
        ); // Mantenha o timestamp mais recente
      }

      return acc;
    }, []);

    // Transformar as coordenadas filtradas em string para o Google Maps
    const coordsString = filteredPositions
      .map((position) => position.coords.join(","))
      .join("/");

    return `${baseUrl}${coordsString}`;
  };


  const generateGoogleMapsLink = (positions) => {
    const baseUrl = "https://www.google.com/maps/dir/";
    const maxPoints = 25;
  
    if (!Array.isArray(positions) || positions.length === 0) {
      return baseUrl;
    }
  
    const limit = Math.min(positions.length, maxPoints);
  
    let selectedPositions;
  
    if (positions.length <= maxPoints) {
      selectedPositions = positions;
    } else {
      const step = Math.floor(positions.length / (limit - 1));
      selectedPositions = [positions[0]];
  
      for (let i = step; i < positions.length - 1; i += step) {
        selectedPositions.push(positions[i]);
      }
  
      selectedPositions.push(positions[positions.length - 1]);
    }
  
    const coordsString = selectedPositions
      .map((position) => {
        if (
          Array.isArray(position.coords) &&
          position.coords.length === 2 &&
          typeof position.coords[0] === "number" &&
          typeof position.coords[1] === "number"
        ) {
          return position.coords.join(",");
        }
        return null;
      })
      .filter(Boolean)
      .join("/");
  
    return `${baseUrl}${coordsString}`;
  };
  


  // const generateGoogleMapsLink = (positions) => {
  //   const baseUrl = "https://www.google.com/maps/dir/";

  //   // Limite de pontos para o Google Maps (25 é o máximo permitido)
  //   const maxPoints = 25;

  //   if (positions.length <= maxPoints) {
  //     // Se o número de posições for menor ou igual ao limite, basta usar todas as posições
  //     const coordsString = positions
  //       .map((position) => position.coords.join(","))
  //       .join("/");
  //     return `${baseUrl}${coordsString}`;
  //   }

  //   // Selecionar os primeiros, últimos e pontos intermediários proporcionalmente
  //   const step = Math.floor(positions.length / (maxPoints - 1)); // -1 para incluir o último ponto
  //   const selectedPositions = [];

  //   // Adiciona o primeiro ponto
  //   selectedPositions.push(positions[0]);

  //   // Adiciona pontos intermediários proporcionalmente
  //   for (let i = step; i < positions.length - 1; i += step) {
  //     selectedPositions.push(positions[i]);
  //   }

  //   // Adiciona o último ponto
  //   selectedPositions.push(positions[positions.length - 1]);

  //   // Gerar a string para o Google Maps com os pontos selecionados
  //   const coordsString = selectedPositions
  //     .map((position) => position.coords.join(","))
  //     .join("/");

  //   return `${baseUrl}${coordsString}`;
  // };

  const fetchFreightData = async () => {
    try {
      // const freightDocRef = db.collection("freight").doc(id);
      // const freightDoc = await freightDocRef.get();
      const freightDoc = await freightService?.getFreightById(id);

      if (!freightDoc.exists) {
        throw new Error("Documento não encontrado");
      }

      const freightData = {
        id: freightDoc.id,
        ...freightDoc.data(),
      };

      // const subcollectionSnapshot = await freightDocRef
      //   .collection("stopping_points")
      //   .get();

      const subcollectionSnapshot = await freightService?.getStoppingPointsByFreight(
        id
      );

      const subcollectionData = subcollectionSnapshot.docs.map((subDoc) => ({
        id: subDoc.id,
        ...subDoc.data(),
      }));

      setFreightData({
        ...freightData,
        subcollectionData,
      });

      const pontos = subcollectionData.map((item) => ({
        coords: [item.latitude, item.longitude],
        popupText: `
          <strong>${item.name}</strong><br/>
          ${item.logradouro}, ${item.number}, ${item.city} - ${item.uf}, ${item.cep}
        `,
        events: item.events || [], // Inclui os eventos associados ao ponto de parada
        operation: item.operation || [],
        concluded: item.concluded || false,
        locationTime:
          item.timestamp ?? item.createdAt ?? item.updatedAt ?? null,
      }));

      // Adiciona os pontos de parada ao estado
      setPoints(pontos);
      // Gerar a URL de pontos de parada
      setStoppingPointsUrl(generateGoogleMapsLink(pontos));
    } catch (err) {
      setError(err);
      console.error("Erro ao buscar dados do frete:", err);
    } finally {
      setLoading(false);
    }
  };

  const searchLatestPositions = async (lastPositionReceived) => {
    try {
      console.log(lastPositionReceived);
  
      const latestPositionsSnapshot = await freightService?.searchLatestPositions(
        id,
        lastPositionReceived
      );
  
      const latestPositions = latestPositionsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
  
      // Criar novas coordenadas
      const coordenadas = latestPositions.map((position) => ({
        coords: [position.latitude, position.longitude],
        timestamp: position.timestamp,
      }));
  
      setPositions((_positions) => {
        const novasPosicoes = coordenadas.filter(
          (novaPosicao) =>
            !_positions.some((pos) => pos.timestamp === novaPosicao.timestamp)
        );
  
        const todasAsPosicoes = [..._positions, ...novasPosicoes];
        // Atualizar a URL com todas as posições
        setPositionsUrl(generateGoogleMapsLink(todasAsPosicoes));
  
        return todasAsPosicoes;
      });
  
      return latestPositions;
    } catch (error) {
      console.error("Erro ao buscar últimas posições:", error);
      return null;
    }
  };

  async function nameDriverFreight(freightData) {
    if (freightData) {
      let data = await driverService.getDriverAvailable(freightData.freight.getDriverFreight.uidDriver);

      const docSnap = await driverService.getDriverAvailable( freightData.freight.getDriverFreight.uidDriver );

      if (docSnap.exists) {
        const driverData = docSnap.data();
        console.log(driverData);
        console.log(driverData.name);

        setNameDriver(driverData.name);
      } else {
        console.log("Motorista não encontrado");
      }
    }
  }

  const generatePublicTrackUrlFromToken = (token) => {
    if (!token) return "";
    return `${window.location.origin}/track/${token}`;
  };

  const generateSecureToken = () => {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  };

  const handleGeneratePublicTrackLink = async () => {
    try {
      setIsGeneratingTrackLink(true);
      const token = generateSecureToken();
      const expiresAt = new Date(
        Date.now() + trackLinkValidityHours * 60 * 60 * 1000
      );
      await freightService.setPublicTrackingData(id, {
        token,
        active: true,
        createdAt: new Date(),
        expiresAt,
      });
      const url = generatePublicTrackUrlFromToken(token);
      setPublicTrackUrl(url);
      await navigator.clipboard.writeText(url);
      alert("Link de rastreio gerado e copiado.");
    } catch (e) {
      console.error("Erro ao gerar link público:", e);
      alert("Não foi possível gerar o link de rastreio.");
    } finally {
      setIsGeneratingTrackLink(false);
    }
  };

  const handleDisablePublicTrackLink = async () => {
    try {
      await freightService.disablePublicTracking(id);
      setPublicTrackUrl("");
      alert("Link de rastreio desativado.");
    } catch (e) {
      console.error("Erro ao desativar link público:", e);
      alert("Não foi possível desativar o link.");
    }
  };

  const handleShareViaWhatsApp = () => {
    if (!publicTrackUrl) {
      alert("Gere um link público antes de compartilhar.");
      return;
    }
    const msg = `Acompanhe a rota em tempo real: ${publicTrackUrl}`;
    const waUrl = `https://wa.me/?text=${encodeURIComponent(msg)}`;
    window.open(waUrl, "_blank", "noopener,noreferrer");
  };

  // const searchLatestPositions = async (lastPositionReceived) => {
  //   try {
  //     console.log(lastPositionReceived);

  //     const latestPositionsSnapshot = await freightService?.searchLatestPositions(
  //       id,
  //       lastPositionReceived
  //     );

  //     const latestPositions = latestPositionsSnapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data(),
  //     }));

  //     // Atualizando o estado com as últimas coordenadas recebidas
  //     const coordenadas = latestPositions.map((position) => ({
  //       coords: [position.latitude, position.longitude],
  //       timestamp: position.timestamp,
  //     }));

  //     // setPositions((_positions) => [..._positions, ...coordenadas]);
  //     setPositions((_positions) => {
  //       const novasPosicoes = coordenadas.filter(novaPosicao =>
  //         !_positions.some(pos => pos.timestamp === novaPosicao.timestamp)
  //       );
  //       return [..._positions, ...novasPosicoes];
  //     });
      

  //     // Gerar a URL de posições

      

  //     const positionCoords = coordenadas.map((pos) => pos.coords);
  //     setPositionsUrl(generateGoogleMapsLink([...positions, ...coordenadas]));

  //     return latestPositions;
  //   } catch (error) {
  //     console.error("Erro ao buscar últimas posições:", error);
  //     return null;
  //   }
  // };

  useEffect(() => {
    fetchFreightData();
    searchLatestPositions(null); // Chamando a função para buscar as últimas posições
  }, []);

  useEffect(() => {
    if (freightData) {
      nameDriverFreight(freightData);
      const existingToken = freightData?.publicTracking?.token;
      const isActive = freightData?.publicTracking?.active !== false;
      const expRaw = freightData?.publicTracking?.expiresAt;
      const createdRaw = freightData?.publicTracking?.createdAt;
      const expMs = expRaw?.toDate
        ? expRaw.toDate().getTime()
        : expRaw
        ? new Date(expRaw).getTime()
        : null;
      const createdMs = createdRaw?.toDate
        ? createdRaw.toDate().getTime()
        : createdRaw
        ? new Date(createdRaw).getTime()
        : null;
      const notExpired = !expMs || expMs > Date.now();
      if (expMs && createdMs && expMs > createdMs) {
        const diffHours = Math.round((expMs - createdMs) / (60 * 60 * 1000));
        if ([24, 72, 168].includes(diffHours)) {
          setTrackLinkValidityHours(diffHours);
        }
      }
      setPublicTrackUrl(
        existingToken && isActive && notExpired
          ? generatePublicTrackUrlFromToken(existingToken)
          : ""
      );
    }
  }, [freightData]);

  useEffect(() => {
    if (points.length > 0) {
      console.log("Pontos no estado:", points);
    }
  }, [points]); // Verificar sempre que `points` for atualizado

  if (useSelector((state) => state.usuarioLogado) <= 0) {
    return <Navigate to="/login" />;
  }

  return (
    <NewMiniDrawer
      divOpen={
        <div className="freight-content-details">
          <div className="container">
            {loading ? (<p>Carregando...</p>) : error ? (<p>Erro ao carregar dados: {error.message}</p>) : points.length > 0 ? (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    marginBottom: 12,
                    padding: "10px 12px",
                    borderRadius: 10,
                    background: "#ffffff",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  {/* <div style={{ display: "flex", alignItems: "center", gap: 10 }}> */}
                    {/* <div
                      style={{
                        fontSize: 11,
                        fontWeight: 800,
                        letterSpacing: 1,
                        color: "#fff",
                        background: "#012443",
                        borderRadius: 999,
                        padding: "5px 10px",
                        lineHeight: 1,
                      }}
                    >
                      FORTIO
                    </div> */}
                    {/* <span style={{ color: "#334155", fontSize: 14 }}>
                      {nameDriver
                        ? `O motorista ${nameDriver} está na estrada realizando as entregas.`
                        : "Acompanhamento em tempo real da rota de entregas."}
                    </span> */}
                  {/* </div> */}
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: 10,
                    marginBottom: 12,
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>
                      Status da viagem
                    </div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>
                      {freightData?.status?.describe || "Em acompanhamento"}
                    </div>
                  </div>
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>
                      Progresso das paradas
                    </div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>
                      {concludedStops}/{points.length} concluida(s) ({progressPercent}%)
                    </div>
                  </div>
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>
                      Ultima leitura GPS
                    </div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>
                      {lastGpsTimestampMs
                        ? isFreightFinished
                          ? travelDurationFromStopsMs !== null
                            ? `Duracao da viagem: ${formatDuration(travelDurationFromStopsMs)}`
                            : "Duracao da viagem indisponivel"
                          : `${new Date(lastGpsTimestampMs).toLocaleString("pt-BR")} (${formatRelativeMinutes(
                              Date.now() - lastGpsTimestampMs
                            )})`
                        : "Sem leitura de GPS"}
                    </div>
                  </div>
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>
                      ETA dinamico
                    </div>
                    <div style={{ fontWeight: 700, color: "#0f172a" }}>
                      {etaData.etaLabel}
                    </div>
                    {etaData.remainingKm !== null && (
                      <div style={{ color: "#64748b", fontSize: 12, marginTop: 4 }}>
                        Distancia restante: {etaData.remainingKm.toFixed(1)} km
                        {etaData.speedKmh
                          ? ` | Velocidade media: ${etaData.speedKmh.toFixed(1)} km/h`
                          : ""}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>
                      Distancia da rota planejada
                    </div>
                    <div style={{ fontWeight: 700, color: routeDeviationDisplay.color }}>
                      {routeDeviationDisplay.text}
                    </div>
                  </div>
                  {isFreightFinished && (
                    <div
                      style={{
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: 10,
                        padding: "10px 12px",
                      }}
                    >
                      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>
                        Resumo da viagem
                      </div>
                      <div style={{ fontWeight: 700, color: "#0f172a" }}>
                        Inicio:{" "}
                        {tripBoundsFromStops.startMs
                          ? new Date(tripBoundsFromStops.startMs).toLocaleString("pt-BR")
                          : "Indisponivel"}
                      </div>
                      <div style={{ fontWeight: 700, color: "#0f172a" }}>
                        Fim:{" "}
                        {tripBoundsFromStops.endMs
                          ? new Date(tripBoundsFromStops.endMs).toLocaleString("pt-BR")
                          : "Indisponivel"}
                      </div>
                      <div style={{ fontWeight: 700, color: "#0f172a" }}>
                        Duracao total:{" "}
                        {travelDurationFromStopsMs !== null
                          ? formatDuration(travelDurationFromStopsMs)
                          : "Indisponivel"}
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>
                      Saude do rastreio
                    </div>
                    <div style={{ fontWeight: 700, color: gpsHealth.tone }}>
                      {gpsHealth.label}
                    </div>
                  </div>
                </div>
                <MapComponent
                  points={points}
                  idFreight={id}
                  searchLatestPositions={searchLatestPositions}
                  mapHeight={640}
                  freightStatusDescribe={freightData?.status?.describe}
                />
                {operationalAlerts.length > 0 && (
                  <div style={{ marginTop: 12, display: "grid", gap: 8 }}>
                    {operationalAlerts.map((alert, idx) => (
                      <div
                        key={`${alert.title}-${idx}`}
                        style={{
                          borderRadius: 10,
                          padding: "10px 12px",
                          border:
                            alert.level === "critical"
                              ? "1px solid #ef4444"
                              : "1px solid #f59e0b",
                          background:
                            alert.level === "critical" ? "#fef2f2" : "#fffbeb",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: 700,
                            color: alert.level === "critical" ? "#b91c1c" : "#92400e",
                            marginBottom: 4,
                          }}
                        >
                          {alert.level === "critical" ? "🔴 " : "🟠 "}
                          {alert.title}
                        </div>
                        <div
                          style={{
                            color: alert.level === "critical" ? "#991b1b" : "#78350f",
                            fontSize: 14,
                          }}
                        >
                          {alert.message}
                        </div>
                        <div
                          style={{
                            marginTop: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 8,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 12,
                              fontWeight: 700,
                              color: alert.level === "critical" ? "#991b1b" : "#78350f",
                            }}
                          >
                            Baseado em: {alert.source || "Sistema"}
                          </span>
                          {alert.mapUrl ? (
                            <a
                              href={alert.mapUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                fontSize: 12,
                                fontWeight: 700,
                                color: "#0f172a",
                                border: "1px solid #cbd5e1",
                                borderRadius: 8,
                                padding: "4px 8px",
                                textDecoration: "none",
                              }}
                            >
                              Ver no mapa
                            </a>
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                {recentOperationalAlerts.length > 0 && (
                  <div
                    style={{
                      marginTop: 12,
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 8,
                      }}
                    >
                      <div style={{ fontWeight: 700, color: "#0f172a" }}>
                        Historico de alertas
                      </div>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button
                          type="button"
                          onClick={() => setHistoryAlertFilter("all")}
                          style={{
                            border:
                              historyAlertFilter === "all"
                                ? "1px solid #012443"
                                : "1px solid #cbd5e1",
                            background: historyAlertFilter === "all" ? "#e6eef6" : "#fff",
                            color: "#0f172a",
                            borderRadius: 999,
                            padding: "4px 10px",
                            cursor: "pointer",
                          }}
                        >
                          Todos
                        </button>
                        <button
                          type="button"
                          onClick={() => setHistoryAlertFilter("critical")}
                          style={{
                            border:
                              historyAlertFilter === "critical"
                                ? "1px solid #7f1d1d"
                                : "1px solid #fecaca",
                            background:
                              historyAlertFilter === "critical" ? "#fee2e2" : "#fff",
                            color: "#7f1d1d",
                            borderRadius: 999,
                            padding: "4px 10px",
                            cursor: "pointer",
                          }}
                        >
                          Criticos
                        </button>
                        <button
                          type="button"
                          onClick={() => setHistoryAlertFilter("warning")}
                          style={{
                            border:
                              historyAlertFilter === "warning"
                                ? "1px solid #92400e"
                                : "1px solid #fde68a",
                            background:
                              historyAlertFilter === "warning" ? "#fffbeb" : "#fff",
                            color: "#92400e",
                            borderRadius: 999,
                            padding: "4px 10px",
                            cursor: "pointer",
                          }}
                        >
                          Avisos
                        </button>
                      </div>
                    </div>
                    <div style={{ display: "grid", gap: 8 }}>
                      {filteredRecentOperationalAlerts.map((item) => (
                        <div
                          key={item.id}
                          style={{
                            borderLeft:
                              item.level === "critical"
                                ? "3px solid #ef4444"
                                : "3px solid #f59e0b",
                            background:
                              item.level === "critical" ? "#fff5f5" : "#fffbeb",
                            borderRadius: 8,
                            padding: "8px 10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: 10,
                              marginBottom: 4,
                            }}
                          >
                            <div style={{ fontWeight: 700, color: "#1e293b" }}>
                              {item.title || "Alerta"}
                            </div>
                            <div style={{ fontSize: 12, color: "#64748b" }}>
                              {formatDateTime(item.createdAt)}
                            </div>
                          </div>
                          <div style={{ color: "#475569", fontSize: 14 }}>
                            {item.message || "Sem detalhes."}
                          </div>
                          <div style={{ marginTop: 4, fontSize: 12, color: "#64748b" }}>
                            Fonte: {item.source || "Sistema"}
                          </div>
                          {item.mapUrl ? (
                            <a
                              href={item.mapUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "inline-block",
                                marginTop: 6,
                                fontSize: 12,
                                fontWeight: 700,
                                color: "#0f172a",
                                border: "1px solid #cbd5e1",
                                borderRadius: 8,
                                padding: "4px 8px",
                                textDecoration: "none",
                              }}
                            >
                              Ver no mapa
                            </a>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {isFreightFinished && (
                  <div
                    style={{
                      marginTop: 12,
                      marginBottom: 4,
                      background: "#1f9d55",
                      color: "#fff",
                      borderRadius: 10,
                      padding: "10px 14px",
                      fontWeight: 600,
                    }}
                  >
                    Este frete já teve as entregas realizadas e foi finalizado.
                  </div>
                )}
                
                <section style={{ marginTop: 16 }}>
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: 10,
                      padding: "12px 14px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        fontWeight: 700,
                        color: "#0f172a",
                        marginBottom: 10,
                      }}
                    >
                      <span>Timeline da viagem</span>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button
                          type="button"
                          onClick={() => setTimelineFilter("all")}
                          style={{
                            border: timelineFilter === "all" ? "1px solid #012443" : "1px solid #cbd5e1",
                            background: timelineFilter === "all" ? "#e6eef6" : "#fff",
                            color: "#0f172a",
                            borderRadius: 999,
                            padding: "4px 10px",
                            cursor: "pointer",
                          }}
                        >
                          Todos
                        </button>
                        <button
                          type="button"
                          onClick={() => setTimelineFilter("alerts")}
                          style={{
                            border: timelineFilter === "alerts" ? "1px solid #012443" : "1px solid #cbd5e1",
                            background: timelineFilter === "alerts" ? "#e6eef6" : "#fff",
                            color: "#0f172a",
                            borderRadius: 999,
                            padding: "4px 10px",
                            cursor: "pointer",
                          }}
                        >
                          Alertas
                        </button>
                        <button
                          type="button"
                          onClick={() => setTimelineFilter("stops")}
                          style={{
                            border: timelineFilter === "stops" ? "1px solid #012443" : "1px solid #cbd5e1",
                            background: timelineFilter === "stops" ? "#e6eef6" : "#fff",
                            color: "#0f172a",
                            borderRadius: 999,
                            padding: "4px 10px",
                            cursor: "pointer",
                          }}
                        >
                          Paradas
                        </button>
                      </div>
                    </div>
                    {filteredTimeline.length > 0 ? (
                      <div style={{ display: "grid", gap: 10 }}>
                        {visibleTimeline.map((item) => (
                          <div
                            key={item.id}
                            style={{
                              borderLeft:
                                item.type === "event"
                                  ? "3px solid #ef4444"
                                  : "3px solid #012443",
                              paddingLeft: 10,
                            }}
                          >
                            <div style={{ fontSize: 12, color: "#64748b" }}>
                              {item.timeMs
                                ? new Date(item.timeMs).toLocaleString("pt-BR")
                                : "Horario indisponivel"}
                            </div>
                            <div style={{ fontWeight: 700, color: "#1e293b" }}>
                              {item.type === "event" ? "⚠️ " : "📍 "}
                              {item.title}
                            </div>
                            <div style={{ color: "#475569", fontSize: 14 }}>
                              {item.description}
                            </div>
                          </div>
                        ))}
                        {filteredTimeline.length > 12 && (
                          <button
                            type="button"
                            onClick={() => setShowFullTimeline((v) => !v)}
                            style={{
                              border: "1px solid #cbd5e1",
                              background: "#fff",
                              color: "#0f172a",
                              borderRadius: 8,
                              padding: "8px 10px",
                              cursor: "pointer",
                              width: "fit-content",
                            }}
                          >
                            {showFullTimeline ? "Ver timeline resumida" : "Ver timeline completa"}
                          </button>
                        )}
                      </div>
                    ) : (
                      <p style={{ margin: 0, color: "#64748b" }}>
                        Sem eventos suficientes para montar a timeline.
                      </p>
                    )}
                  </div>
                </section>

                <section
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    width: "100%",
                    gap: 10,
                    paddingTop: '20px'
                  }}
                >
                  <div style={{ width: "50%"}}>
                    {/* <h3>Coordenadas coletadas</h3> */}
                    <a
                      href={positionsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ver no Maps
                    </a>
                    
                    <table>

                    {freightData ? (

                      <CardFolowFreigth 
                          numberSerial={freightData.numberSerial}
                          product={freightData.freight.product}
                          weightCargo={freightData.freight.weightCargo}
                          valueNF={freightData.freight.valueNF}
                          valueFreightage={freightData.freight.valueFreightage}
                          user={freightData.user}
                          clientPayment={freightData.clientPayment}
                          vehicle={freightData.vehicle}
                          typeBodywork={freightData.vehicle?.typeBodywork?.dados ?? "Tipo não informado"}
                          typeVehicle={freightData.vehicle.typeVehicle.dados}
                          nameDriver={nameDriver}
                      />

                    ) : (
                      <ul>
                        <li>Dados do frete indisponíveis.</li>
                      </ul>
                    )}

                    </table>

                    <div style={{ marginTop: 10, marginBottom: 12, marginTop: 20 }}>
                      <div style={{ marginBottom: 8 }}>
                        <label style={{ marginRight: 8, fontWeight: 600 }}>
                          Validade:
                        </label>
                        <select
                          value={trackLinkValidityHours}
                          onChange={(e) =>
                            setTrackLinkValidityHours(Number(e.target.value))
                          }
                          style={{
                            border: "1px solid #d1d5db",
                            borderRadius: 8,
                            padding: "6px 8px",
                          }}
                        >
                          <option value={24}>24 horas</option>
                          <option value={72}>72 horas</option>
                          <option value={168}>7 dias</option>
                        </select>
                      </div>
                      <button
                        type="button"
                        onClick={handleGeneratePublicTrackLink}
                        disabled={isGeneratingTrackLink}
                        style={{
                          border: "none",
                          background: "#012443",
                          color: "#fff",
                          padding: "8px 12px",
                          borderRadius: 8,
                          cursor: "pointer",
                          marginRight: 8,
                        }}
                      >
                        {isGeneratingTrackLink
                          ? "Gerando..."
                          : "Gerar link público"}
                      </button>
                      <button
                        type="button"
                        onClick={handleDisablePublicTrackLink}
                        style={{
                          border: "1px solid #c62828",
                          background: "#fff",
                          color: "#c62828",
                          padding: "8px 12px",
                          borderRadius: 8,
                          cursor: "pointer",
                        }}
                      >
                        Desativar link
                      </button>
                      <button
                        type="button"
                        onClick={handleShareViaWhatsApp}
                        disabled={!publicTrackUrl}
                        style={{
                          border: "none",
                          background: "#25D366",
                          color: "#fff",
                          padding: "8px 12px",
                          borderRadius: 8,
                          cursor: publicTrackUrl ? "pointer" : "not-allowed",
                          marginLeft: 8,
                        }}
                      >
                        Compartilhar WhatsApp
                      </button>
                      {publicTrackUrl && (
                        <div style={{ marginTop: 8, wordBreak: "break-all" }}>
                          {/* <a
                            href={publicTrackUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {publicTrackUrl}
                          </a> */}
                          <div
                            style={{
                              marginTop: 10,
                              display: "inline-block",
                              background: "#fff",
                              padding: 8,
                              borderRadius: 8,
                              border: "1px solid #e5e7eb",
                            }}
                          >
                            <QRCodeCanvas value={publicTrackUrl} size={132} />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={{ width: "50%", marginBottom: 5 }}>
                    {/* <h3>Pontos de Parada</h3> */}
                    <a
                      href={stoppingPointsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ver no Maps
                    </a>
                    <table className="table-pontos-de-parada">
                      
                      {freightData && freightData?.subcollectionData?.length > 0 ? (
                        
                        <StepPoints listPoints={freightData} />

                      ) : (
                        <li>Nenhum dado de ponto de parada disponível.</li>
                      )}
                    </table>
                  </div>

                </section>
              </>
            ) : (
              <p>Nenhum ponto de parada encontrado.</p>
            )}
          </div>






        </div>
      }
    />
  );
}
